export default {
  welcome: 'Hello anh em han quoc',
};
